import _ from "lodash";
import {
  SHOW_SUPPLIED_BY_POPUP,
  HIDE_SUPPLIED_BY_POPUP
} from "../actions/types";

const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SHOW_SUPPLIED_BY_POPUP:
      return true;
    case HIDE_SUPPLIED_BY_POPUP:
      return false;
    default:
      return state;
  }
};